import React, { useEffect, useState } from "react";
import "../css/networkList.css";
import {BASE_URL} from "../constants"
import { useLanguage } from "../components/Language.js";

function NetworkList({ username, fromEvent, fromProfile, eventId, onClose }) {
    const [network, setNetwork] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [message, setMessage] = useState("");
    const [selectedUser, setSelectedUser] = useState(null);
    const [showInviteAllBox, setShowInviteAllBox] = useState(false);

    const {language} = useLanguage();

    const translations = {
        en: {
            inviteSent: `Invite sent to ${username}`,
            inviteSentToAll: "Invites sent to all users in the network!",
            eventNotFound: "Event not found.",
            inviteAll: "Invite All",
            confirmInvite: "Confirm Invite",
            loading: "Loading...",
            deleteFromNetwork: "Delete from network",
            sendInvite: "Send Invite",
            noUsersInYourNetwork: "No users in your network.", 
            network: "network",
            cancel: "Cancel",
            close: "Close",
        },

        gd: {
            inviteSent: `Cuireadh air a chur gu ${username}`,
            inviteSentToAll: "Cuiridhean air an cur gu luchd-cleachdaidh san lìonra!",
            eventNotFound: "Cha do lorgadh an tachartas.",
            inviteAll: "Cuir Cuireadh gu na h-Uile",
            confirmInvite: "Dearbh Cuireadh",
            loading: "Luchdachadh ...",
            deleteFromNetwork: "Dùbh às bhon lìonra",
            sendInvite: "Cuir Cuireadh",
            noUsersInYourNetwork: "Chan eil luchd-cleachdaidh sam bith san lìonra agad.",
            network: "Lìonra",
            cancel: "Dubh às",
            close: "Dùin",
            
        },
    };

    const fetchNetwork = async () => {
        try {
            const response = await fetch(
                `${BASE_URL}/api/list_network/${username}/`
            );
            if (response.ok) {
                const data = await response.json();
                setNetwork(data.network);
            } else {
                console.error("Failed to fetch network");
            }
        } catch (error) {
            console.error("Error fetching network:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchNetwork();
    }, [username]);

    const handleRemoveFromNetwork = async (username, otherUsername) => {
        console.log("Removing from network:", username, otherUsername);
        try {
            const response = await fetch(`${BASE_URL}/api/remove_from_network/`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ username, other_username: otherUsername }),
            });
            if (response.ok) {
                await fetchNetwork();
            } else {
                console.error("Failed to remove from network.");
            }
        } catch (error) {
            console.error("Error removing user:", error);
        }
    };

    const handleSendInvite = async (invitedBy, invitedUsername, eventId, message) => {
        console.log("Sending invite:", invitedBy, invitedUsername, eventId, message);
        try {
            const response = await fetch(`${BASE_URL}/api/send_invite/`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ invitedBy, invitedUsername, eventId, message }),
            });
            if (response.ok) {
                const data = await response.json();
                await fetchNetwork();
                setSelectedUser(null);
                alert(` ${data.message} for event ${data.event_title}.`);
            } else {
                console.error("Failed to send invite.");
            }
        } catch (error) {
            console.error("Error sending invite:", error);
        }
    };

    const handleInviteAll = async () => {
        console.log("Inviting all users with message:", message);
        try {
            const response = await fetch(`${BASE_URL}/api/invite_all_network/`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    invited_by: username,
                    event_id: eventId,
                    message: message,
                }),
            });
            if (response.ok) {
                const data = await response.json();
                alert(`${translations[language].invitesSentToAll}`);
                setShowInviteAllBox(false);
            } else {
                console.error("Failed to invite all.");
            }
        } catch (error) {
            console.error("Error inviting all:", error);
        }
    };

    return (
        <div className="network-list-overlay">
            <h3>{username}'s {translations[language].network}</h3>

            {fromEvent && (
                <>
                    <button onClick={() => setShowInviteAllBox(true)}>{translations[language].inviteAll}</button>
                    {showInviteAllBox && (
                        <div className="invite-all-container">
                            <textarea
                                placeholder="Write a message for all invites..."
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                            />
                            <div className="invite-all-buttons">
                                <button onClick={handleInviteAll}>{translations[language].confirmInvite}</button>
                                <button onClick={() => setShowInviteAllBox(false)}>{translations[language].cancel}</button>
                            </div>
                        </div>
                    )}
                </>
            )}


            {isLoading ? (
                <p>{translations[language].loading}</p>
            ) : (
                <ul>
                    {network.length > 0 ? (
                        network.map((user) => (
                            <li key={user.username}>
                                {/* <a href={`/profile/${user.username}`}>
                                    {user.username}
                                </a> ({user.email}) */}
                                {user.username} ({user.email})
                                {fromProfile && (
                                    <button
                                        onClick={() => handleRemoveFromNetwork(username, user.username)}
                                    >
                                        {translations[language].deleteFromNetwork}
                                    </button>
                                )}
                                {fromEvent && (
                                    <>
                                        <button
                                            onClick={() => setSelectedUser(user.username)}
                                        >
                                            {translations[language].sendInvite}
                                        </button>
                                        {selectedUser === user.username && (
                                            <div className="invite-message-container">
                                                <textarea
                                                    placeholder="Write a message..."
                                                    value={message}
                                                    onChange={(e) => setMessage(e.target.value)}
                                                />
                                                <button
                                                    onClick={() =>
                                                        handleSendInvite(username, user.username, eventId, message)
                                                    }
                                                >
                                                    {translations[language].confirmInvite}
                                                </button>
                                                <button
                                                    onClick={() => setSelectedUser(null)}
                                                >
                                                    {translations[language].cancel}
                                                </button>
                                            </div>
                                        )}
                                    </>
                                )}
                            </li>
                        ))
                    ) : (
                        <p>{translations[language].noUsersInYourNetwork}</p>
                    )}
                </ul>
            )}

            <button onClick={onClose}>{translations[language].close}</button>
        </div>
    );
}

export default NetworkList;
